export const LANGS = [
  { code: "pt", label: "Português", flag: "🇵🇹" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "ur", label: "Roman Urdu", flag: "🇵🇰" },
];

export const T = {
  pt: {
    tagline: "Preparação para o exame TVDE",
    heroTitle: "Domina o exame\nTVDE com clareza.",
    heroSub: "316 perguntas oficiais organizadas por categoria, com traduções e simulados de 30 perguntas. Estuda ao teu ritmo.",
    getStarted: "Começar agora",
    login: "Entrar",
    apply: "Candidatar-me",
    logout: "Sair",
    categories: "Categorias",
    dashboard: "Painel",
    startMock: "Iniciar simulado",
    questions: "perguntas",
    exam: "Exame",
    submit: "Submeter",
    next: "Seguinte",
    prev: "Anterior",
    time: "Tempo",
    score: "Pontuação",
    passed: "Aprovado",
    failed: "Reprovado",
    correctAnswer: "Resposta correta",
    explanation: "Explicação",
    yourAnswer: "A tua resposta",
    review: "Rever exame",
    progress: "Progresso",
    email: "E-mail",
    password: "Palavra-passe",
    name: "Nome",
    checkAnswer: "Verificar",
    tryAgain: "Tentar de novo",
    correct: "Correto!",
    incorrect: "Incorreto",
  },
  en: {
    tagline: "TVDE license exam prep",
    heroTitle: "Master the TVDE\nexam with clarity.",
    heroSub: "316 official questions organized by category, with translations and 30-question mock exams. Study at your pace.",
    getStarted: "Get started",
    login: "Log in",
    apply: "Apply now",
    logout: "Log out",
    categories: "Categories",
    dashboard: "Dashboard",
    startMock: "Start mock exam",
    questions: "questions",
    exam: "Exam",
    submit: "Submit",
    next: "Next",
    prev: "Previous",
    time: "Time",
    score: "Score",
    passed: "Passed",
    failed: "Failed",
    correctAnswer: "Correct answer",
    explanation: "Explanation",
    yourAnswer: "Your answer",
    review: "Review exam",
    progress: "Progress",
    email: "Email",
    password: "Password",
    name: "Name",
    checkAnswer: "Check",
    tryAgain: "Try again",
    correct: "Correct!",
    incorrect: "Incorrect",
  },
  ur: {
    tagline: "TVDE license exam ki tayaari",
    heroTitle: "TVDE exam ko\nclarity ke sath master karo.",
    heroSub: "316 official sawalaat categories mein tarteeb se, translations aur 30-sawaal ke mock exams ke sath. Apni raftaar se parho.",
    getStarted: "Shuru karo",
    login: "Log in",
    apply: "Apply karo",
    logout: "Log out",
    categories: "Categories",
    dashboard: "Dashboard",
    startMock: "Mock exam shuru karo",
    questions: "sawalaat",
    exam: "Imtihaan",
    submit: "Jama karo",
    next: "Agla",
    prev: "Pichla",
    time: "Waqt",
    score: "Score",
    passed: "Pass",
    failed: "Fail",
    correctAnswer: "Sahi jawab",
    explanation: "Wazahat",
    yourAnswer: "Aap ka jawab",
    review: "Exam dobara dekhen",
    progress: "Progress",
    email: "Email",
    password: "Password",
    name: "Naam",
    checkAnswer: "Check karo",
    tryAgain: "Dobara try karo",
    correct: "Sahi!",
    incorrect: "Ghalat",
  },
};

export function getLang() {
  const stored = typeof window !== "undefined" ? localStorage.getItem("tvde_lang") : null;
  return stored || "pt";
}

export function setLang(l) {
  localStorage.setItem("tvde_lang", l);
  window.dispatchEvent(new Event("lang-change"));
}

export function t(lang, key) {
  return T[lang]?.[key] || T.pt[key] || key;
}
